/* Client router. Three routes:
     /            landing + search
     /c/{slug}    single operator (company)
     /g/{slug}    brand group (aggregated)
*/

import { renderLanding } from "./landing";

const app = document.getElementById("app")!;

function nav(path: string): void {
  if (path !== location.pathname) history.pushState({}, "", path);
  route();
}

async function route(): Promise<void> {
  const path = location.pathname;
  const company = path.match(/^\/c\/(.+)$/);
  const group = path.match(/^\/g\/(.+)$/);
  const vessel = path.match(/^\/v\/(.+)$/);
  const loc = path.match(/^\/l\/(.+)$/);
  const settefisk = path.match(/^\/s\/(.+)$/);
  const cohort = path.match(/^\/cohort\/(.+)$/);
  const owner = path.match(/^\/o\/(.+)$/);
  const plant = path.match(/^\/p\/(.+)$/);
  const play = path === "/play";
  const present = path === "/present";
  const demoBlom = path === "/demo-blom";
  const demoLus = path === "/demo-lus" || path.startsWith("/demo-lus/");

  if (demoLus) {
    const { renderDemoLus } = await import("./demoLus");
    renderDemoLus(app, nav);
  } else if (demoBlom) {
    const { renderDemoBlom } = await import("./demoBlom");
    await renderDemoBlom(app, nav);
  } else if (present) {
    const { renderPresent } = await import("./present");
    await renderPresent(app, nav);
  } else if (play) {
    const { renderFjordle } = await import("./fjordle");
    await renderFjordle(app, nav);
  } else if (company) {
    const { renderCompany } = await import("./company");
    await renderCompany(app, decodeURIComponent(company[1]), nav);
  } else if (group) {
    const { renderGroup } = await import("./group");
    await renderGroup(app, decodeURIComponent(group[1]), nav);
  } else if (vessel) {
    const { renderVessel } = await import("./vessel");
    await renderVessel(app, decodeURIComponent(vessel[1]), nav);
  } else if (loc) {
    const { renderLocation } = await import("./location");
    await renderLocation(app, decodeURIComponent(loc[1]), nav);
  } else if (settefisk) {
    const { renderSettefisk } = await import("./settefisk");
    await renderSettefisk(app, decodeURIComponent(settefisk[1]), nav);
  } else if (cohort) {
    const { renderCohort } = await import("./cohort");
    await renderCohort(app, decodeURIComponent(cohort[1]), nav);
  } else if (owner) {
    const { renderOwner } = await import("./owner");
    await renderOwner(app, decodeURIComponent(owner[1]), nav);
  } else if (plant) {
    const { renderPlant } = await import("./plant");
    await renderPlant(app, decodeURIComponent(plant[1]), nav);
  } else {
    renderLanding(app, nav);
  }
  if (path !== "/") window.scrollTo(0, 0);
}

window.addEventListener("popstate", route);

// Intercept same-origin link clicks for SPA navigation.
document.addEventListener("click", (e) => {
  const a = (e.target as HTMLElement)?.closest?.("a");
  if (!a) return;
  const href = a.getAttribute("href");
  if (!href || !href.startsWith("/") || a.target === "_blank") return;
  e.preventDefault();
  nav(href);
});

route();
